export default "__VITE_ASSET__Dn1mU9yl__"